import { Button, Stack, Typography, useTheme } from "@mui/material";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";

interface NotificationCenterErrorProps {
	handleRetry: () => void;
}

export default function NotificationCenterError({
	handleRetry,
}: NotificationCenterErrorProps) {
	const theme = useTheme();
	const { t } = useResource();

	return (
		<Stack
			height="60vh"
			justifyContent="center"
			alignItems="center"
			gap={1.6}
			padding="0 32px"
			data-testid="notification-center-upcoming-error"
		>
			<Typography
				fontSize={14}
				fontWeight={500}
				color={theme.palette.grey[700]}
				textAlign="center"
			>
				{t(Resources.NotificationCenter.Common.LoadingError)}
			</Typography>
			<Button variant="outlined" onClick={handleRetry}>
				{t(Resources.NotificationCenter.Common.Retry)}
			</Button>
		</Stack>
	);
}
